import { Box } from "@mui/material";
import BannerComponent from "../../Components/BannerComponent";
import "./index.css";
import ButtonComponent from "../../Components/ButtonComponent";
import useScreenSize from "../../hooks/useScreenSize";

const Ourpolicies = () => {
  const { isLessThanMd } = useScreenSize();

  return (
    <Box
    className=""
    sx={{
        margin: isLessThanMd ? "0px 20px 50px 20px" : "0px 0px 50px 0px",
    }}
>
      <Box className="container">
        <BannerComponent
          sectionTitle="Our Policies"
          title="Our policies ensure transparency"
          body="Explore our policies to understand our commitment to transparency, fairness, and your rights."
        />
      </Box>
      <Box className="container">
        <header className="policy-header">
          {/* <h1>Policy Overview & Terms of Use</h1> */}
        </header>
        <section className="policy-section">
          <h2>Privacy Policy </h2>
          <p>
            The TRESOR MICRO FEDERATION (TMF) is a government-owned organization
            established in 2023, focused on providing affordable credit and
            business development services. This privacy notice outlines how we
            collect, use, and protect your personal data when you interact with
            our platforms, such as signing up for services, events, or
            newsletters, or when using our websites and mobile applications. The
            personal data we may collect includes contact information, account
            details, demographic data, and visual images from social media or
            events. We use this data to deliver services, communicate updates,
            run promotional activities, and provide customer support.
          </p>
          <p>
            We may share your personal information with third-party service
            providers who assist us with technical, marketing, or legal
            services, but only as necessary and in line with this privacy
            notice. We also take steps to ensure your data is protected through
            security measures and limit access to those who need it for business
            purposes. You have the right to access, correct, or delete your
            data, and you can opt out of marketing communications at any time.
            If you have concerns about how your data is used, you can contact us
            directly.
          </p>
          <p>
            <a
              href="/assets/documents/privacyPolicy.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ButtonComponent
                sx={{ marginBottom: "20px" }}
                type="button"
                value="Read More"
              />
            </a>
          </p>
        </section>
        <hr />
        <section className="policy-section">
          <h2>Refund Policy</h2>
          <p>
            TMF's Refund Policy outlines the procedure for claiming a refund in
            cases of excess payments made by users for loan repayments. Once a
            payment is successfully processed, it cannot be canceled, and any
            failed transactions should be resolved through the user's bank or
            card provider. If a user makes multiple payments resulting in an
            excess credit to TMF’s account, the excess amount will be applied to
            outstanding dues or installment payments. Refund claims must be made
            within 7 working days, and upon verification, a refund will be
            processed within 30 calendar days. Refunds are typically issued to
            the original payment method, but timing depends on the bank's
            processing policies, and no interest is paid during this process.
          </p>
          <p>
            TMF is not responsible for failed or delayed payment instructions
            due to incomplete details, insufficient funds, bank refusal, or
            external factors like natural disasters or system failures.
            Additionally, TMF may suspend or terminate its online payment
            services at its discretion, without notice.
          </p>
          <p>
            <a
              href="/assets/documents/refundPolicy.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ButtonComponent
                sx={{ marginBottom: "20px" }}
                type="button"
                value="Read More"
              />
            </a>
          </p>
        </section>
        <hr />
        <section className="policy-section">
          <h2>Terms and Conditions</h2>
          <p>
            Tresor Micro Finance (TMF) acts as an intermediary connecting
            lenders and borrowers via its website and mobile app, where all
            transactions are at the discretion of the users. TMF does not
            guarantee the repayment of loans or returns on investments, and the
            risks, including potential loss of principal and interest, are
            solely borne by the lender. Users must be Indian citizens aged 18 or
            older, and provide documents like PAN, Aadhaar, or Passport.
          </p>
          <p>
            TMF charges applicable fees for transactions, which are disclosed to
            users prior to processing. TMF is not liable for any losses arising
            from compromised account details, and users are responsible for
            maintaining account security. In case of disputes, the district
            court is the sole legal authority for resolution. processing
            policies, and no interest is paid during this process.
          </p>
          <p>
            <a
              href="/assets/documents/termAndCondition.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ButtonComponent
                sx={{ marginBottom: "20px" }}
                type="button"
                value="Read More"
              />
            </a>
          </p>
        </section>
      </Box>
    </Box>
  );
};

export default Ourpolicies;
